import axios from 'axios';

export function upload(endpoint, formdata, options = { token: '', traceId: '' }) {
    const { token, traceId } = options;

    return new Promise((resolve) => {
        const reqHeaders = {
            authorization: 'Bearer ' + token,
            'x-trace-id': traceId,
            'content-type': 'multipart/form-data',
        };
        axios.post(endpoint, formdata, { headers: reqHeaders })
            .then(resolve)
            .catch(resolve);
    });
}

export default upload;
